export const defaultValues = {
  platform: null,
  accountId: '',
  storeName: '',
  brand: null,
  accountType: null,
  parentAccount: null,
};
